import 'whatwg-fetch';
import config, {AUTH_INVALID_MESSAGE, AUTH_INVALID_TOKEN, SERVICE_LOGICAL_ACCESS_DENIED} from '../../config/config';
import {dropToken} from "../../components/UserLogin/actions";
import {toastr} from "react-redux-toastr";

export const SEARCH_PAGE_COUNT = 20;
export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const RECEIVE_SEARCH = 'RECEIVE_SEARCH';
export const RECEIVE_SEARCH_UPDATE = 'RECEIVE_SEARCH_UPDATE';
export const SET_SEARCH_CONTEXT = 'SET_SEARCH_CONTEXT';

export const SEARCH_CONTEXT_TASKS = 'tasks';
export const SEARCH_CONTEXT_ORDERS = 'orders';
export const SEARCH_CONTEXT_PRODUCTS = 'products';
export const SEARCH_CONTEXT_UNSET = '/';
export const SEARCH_CONTEXT_DEFAULT = config.DEFAULT_SEARCH_IN;

export const SEARCH_CONTEXTS = [
    { key: SEARCH_CONTEXT_TASKS, text: 'Задачи', value: SEARCH_CONTEXT_TASKS, title: 'в задачах' },
    { key: SEARCH_CONTEXT_PRODUCTS, text: 'Продукты', value: SEARCH_CONTEXT_PRODUCTS, title: 'в продуктах' },
]

export const setSearchContext = (value) => {
    return {
    type: SET_SEARCH_CONTEXT,
    value,
}
};
export const receiveSearch = (context, page, items) => ({
    type: RECEIVE_SEARCH,
    items,
    page,
    context,
});

export const receiveSearchUpdate = (context, page, items) => ({
    type: RECEIVE_SEARCH_UPDATE,
    items,
    page,
    context,
});

export const requestSearch = (context, page) => ({
    type: REQUEST_SEARCH,
    page,
    context,
});

const process_api_error = (json, dispatch) => {
  if (json.code === AUTH_INVALID_TOKEN) {
        dispatch(dropToken());
        toastr.error(AUTH_INVALID_MESSAGE);
  } else
      if (json.code === SERVICE_LOGICAL_ACCESS_DENIED)
        toastr.error(json.message);
      else
        toastr.error('Ошибка сервера: ' + String(json.code) + '. ' + json.message);
};

export const fetchSearch = (token, context, params = {}) => (dispatch) => {

  dispatch(requestSearch(context, params.page));

  let base_url, headers = {};
  switch (context) {
      case SEARCH_CONTEXT_TASKS:
          base_url = config.API_TASKS_URL;
          headers = { Authorization: 'Bearer ' + token };
          break;
      case SEARCH_CONTEXT_ORDERS:
          base_url = config.API_ORDERS_URL;
          headers = { Authorization: 'Bearer ' + token };
          break;
      case SEARCH_CONTEXT_PRODUCTS:
          base_url = config.API_PRODUCTS_URL;
          break;
      default:
          base_url = config.API_PRODUCTS_URL;
          break;
  }

  if (!_.isEmpty(headers) && !token) {
      toastr.error(AUTH_INVALID_MESSAGE);
      dispatch(receiveSearch(context, params.page, []));
      return;
  }

  const url = base_url
        + '?' + Object.keys(params).map((k) => k + '=' + encodeURIComponent(params[k])).join('&')
        + '&version=' + config.APP_VERSION;

  return fetch(url, {headers})
    .then((response) => response.json())
      .then((json) => {
        if (json.code ?? 200 === 200) {
          dispatch(receiveSearch(context, params.page, json.data ?? json));
        } else {
          process_api_error(json, dispatch);
        }
      })
      .catch( (ex) => toastr.error('Ошибка запроса: ' + String(ex)));
};
